import React, {useState, useEffect, useRef} from 'react'
import {ParagraphText, Button} from '@thryvlabs/maverick'
import {client} from '../utils/api-client'
import {toast} from 'react-toastify'
import {AppSpinner} from '../components/custom/loader-spinner'
import {KCPPaymentDetails} from '../components/subscription-summary'
import {PaymentMethodComponent} from '../components/payment-method'
import {useLocation, useNavigate} from 'react-router-dom'
import {AgreedTermNote} from '../components/agreed-term-note'
import {formatInCodeQuantityStructure, formatSubDetails} from '../utils/util'
import {useAsync} from '../utils/use-async'
import {LoadingTimelineModal} from '../components/custom/loading-timeline'
import dayjs from 'dayjs'
import CountdownTimer from '../components/countdown-timer'
import {BlueGradientBackground} from '../components/AuthForm'
import {ThryvAndKeapHeader} from './order-details'
import '../styles/formScreensStyles.css'
import {kP11LinkService} from '../components/keap-scheduler-v2/kp-11Link-service'
import {useBillingInfo} from '../components/keap-partner/payment-information-components/contexts/billing-info-context'
import {ccCurrencyCodes} from '../utils/currency-format'
import {PAYMENT_METHODS} from '../components/keap-partner/payment-information-components/constants'
import {usePaymentOrder} from '../components/keap-partner/payment-information-components/hooks/use-payment-order'
import {useRecurlyPayment} from '../components/keap-partner/payment-information-components/contexts/recurly-payment-context'
import {usePaymentCheckboxes} from '../components/keap-partner/payment-information-components/contexts/payment-checkboxes-context'
import {OverlayLoader} from '../ui-view/payment-information'
import {useDispatch, useSelector} from 'react-redux'
import {nextPaymentStep} from '../redux/paymentScreenViewSlice'
import {AutopayTerms} from '../components/autopay-terms'
import {clearRecurlyTokenData} from '../redux/recurlySlice'

const dataJSON = {}
const VALIDITY_IN_HOUR_IN_MS = 3601000
const NON_ADDED_PLANS = [
  'addon-5-signatures_usage',
  'app-websitebuilder',
  'cc_basicpls-5-thryv-m2m',
  'thryvprfee',
]

export const PaymentDetailsComponent = () => {
  const {isFetching, isVerifying, setRecurlyAccountId, setIsFetching} =
    useBillingInfo()
  const [paymentMethod, setPaymentMethod] = useState(PAYMENT_METHODS[0])
  const {checkBoxesValues, setCheckBoxesValues, isAgreeCheckboxDisabled} =
    usePaymentCheckboxes()
  //const [agreedTermValue, setAgreedTermValue] = useState(false)
  const [cartDetailObj, setCartDetailObj] = useState({})
  const [subscriptionList, setSubscriptionList] = useState({})
  const [preselectedSubData, setPreselectedSubData] = useState({})
  const [payloadData, setPayloadData] = useState({})
  const [paymentUUID, setPaymentUUID] = useState('')
  const [orderId, setOrdreId] = useState('')
  const setRecurlyToken = () => {} // Placeholder
  const [isTaxCalculated, setTaxCalculateStatus] = useState(false)
  const thryvId = useRef('')
  const [isLoading, setIsLoading] = useState(false)
  const [calculatingTaxes, setCalculatingTaxes] = useState(false)
  const finalBillingAmountDetails = {}
  const [previewDetails, setPreviewDetails] = useState({})
  const [scheduleDetails, setScheduleDetails] = useState([])
  const [linkExpiryInMinutes, setLinkExpiryInMinutes] = useState(
    VALIDITY_IN_HOUR_IN_MS,
  )
  const [listItem, setListItem] = useState({
    centers: [],
    apps: [],
    oneTimeFees: [],
  })
  const navData = useLocation()
  const currentStep = useRef(1)
  const {paymentCurrentStep} = useSelector(state => state.paymentScreenView)

  const dispatch = useDispatch()
  console.log({paymentCurrentStep})
  const captureOrderHeaderId = useRef(null)
  const [isLoadingTimelineCompleted, setLoadingTimelineCompletionStatus] =
    useState(false)
  const [hasScrolledToTop, setHasScrolledToTop] = useState(false)

  const {run} = useAsync({
    status: 'pending',
  })
  const navigate = useNavigate()
  const transitionData = useLocation()
  const linkType = navData?.state?.linkType
  const _isLoading = isLoading || isFetching || isVerifying
  const {isCVCVerified} = useBillingInfo()
  const {is5Order} = usePaymentOrder()
  const {clearRecurlyToken, recurlyToken, setType} = useRecurlyPayment()
  //const {isAgreeCheckboxDisabled} = usePaymentCheckboxes()
  // const agreedTerms = checkBoxesValues.agreedTerms
  const {isMobileViewEnable} = useSelector(state => state.screenView)
  const {recurlyTokenDetail} = useSelector(state => state.recurlyTokenData)
  console.log({'payment details': isMobileViewEnable})
  useEffect(() => {
    if (isMobileViewEnable) {
      setPaymentMethod({name: '', value: '', icon: ''})
    } else {
      setPaymentMethod(PAYMENT_METHODS[0])
    }
  }, [isMobileViewEnable])

  useEffect(() => {
    let countryCode
    let currency

    const getOrderDetail = async () => {
      try {
        const id = navData?.state?.id || navData?.state?.linkId

        let data = await client(`cc/order/keapClient/fetchOrder?id=${id}`)
        // let data = await client(
        //   `cc/order/keapClient/fetchOrder?id=${navData?.state?.id}`,
        // )
        countryCode = data.country_code
        currency = ccCurrencyCodes[data.country_code]

        let subList = await client(`plans/5/v1/list`)
        setSubscriptionList(subList)
        setPreselectedSubData(data)
        console.log(preselectedSubData)
        transitionData.state.keapPartnerLinkDetail = data
        transitionData.state.linkId = data.id
        setPaymentUUID(data.payment_uuid)
        setOrdreId(data.cc_order_id)
        console.log('keapPartnerLinkDetail data:', data)
        console.log(
          'country_code from keapPartnerLinkDetail:',
          data?.country_code,
        )
        if (linkType === '1:1') {
          console.log('inside the getOrder Details ===>', {data})
          try {
            let previewResponse = await client(
              `cc/order/purchase-plan/${data.payment_uuid}`,
            )
            // console.log({previewResponse})
            setPreviewDetails(previewResponse)
            if (previewResponse?.recurlyAccountId) {
              setRecurlyAccountId(previewResponse?.recurlyAccountId)
            }
          } catch (err) {
            console.log(err)
            return undefined
          }
          try {
            const scheduleData = await client(
              `keappartner/fetchScheduleDetails/${data.order_id}`,
            )
            if (scheduleData.success) {
              setScheduleDetails(scheduleData.data)
            }
          } catch (err) {
            console.log(err)
          }
        }
        let oneTimeFees = []
        if (data?.add_on_code?.oneTimeFees) {
          oneTimeFees = data?.add_on_code?.oneTimeFees
        }
        //validate coupons
        const codes = []
        let coupons = []
        // adding the plans into the coupon validation
        if (data?.plan_code.plan && data?.plan_code.plan.length > 0) {
          for (const plan of data.plan_code.plan) {
            if (!plan.code.startsWith('cc')) {
              codes.push(plan.code)
            }
          }
        }

        // adding the addons into the coupon validation
        if (data?.add_on_code?.addon && data?.add_on_code?.addon.length > 0) {
          for (const addon of data.add_on_code.addon) {
            if (!addon.code.startsWith('cc')) {
              codes.push(addon.code)
            }
          }
        }

        if (
          data?.coupon_code?.couponCodes &&
          data?.coupon_code?.couponCodes.length > 0
        ) {
          for (const coupon of data.coupon_code.couponCodes) {
            const couponDetails = await run(
              client(
                `orders/coupon/validate?couponCode=${coupon}&country=${countryCode}&planCode=${codes.join()}`,
              ),
            )
            if (couponDetails && couponDetails?.isValid) {
              coupons.push(couponDetails)
            }
          }
        }

        if (
          data?.default_incentive?.defaultIncentives &&
          data?.default_incentive?.defaultIncentives.length > 0
        ) {
          for (const coupon of data.default_incentive.defaultIncentives) {
            const couponDetails = await run(
              client(
                `orders/coupon/validate?couponCode=${coupon}&country=${countryCode}&planCode=${codes.join()}`,
              ),
            )
            if (couponDetails && couponDetails?.isValid) {
              coupons.push(couponDetails)
            }
          }
        }

        let cartObj = formatSubDetails(
          {
            plan: [...data.plan_code.plan],
            addons: [...data.add_on_code.addon],
            oneTimeFees,
            coupons,
          },
          subList,
          currency,
        )

        setCartDetailObj(cartObj)
        transitionData.state.orderDetail = cartObj
      } catch (err) {
        console.log('errror', err)
      }
    }

    getOrderDetail()

    console.log({subscriptionList, cartDetailObj, data: transitionData.state})
    if (transitionData.state) {
      setPayloadData(transitionData.state)
    }
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

    const preLoadApiCall = async () => {
      try {
        if (linkType === '1:1') {
          setIsLoading(false)
          setLoadingTimelineCompletionStatus(true)
          const response = await run(
            client(`orders/validate-emailaccount/${navData?.state?.custEmail}`),
          )
          let accountInformation = {
            firstName: response.firstName,
            lastName: response.lastName,
            city: response.city,
            state: response.state,
            address: response.address,
            company: response.company,
            postCode: response.postCode,
          }
          console.log({response})
          console.log({accountInformation})
          if (response?.thryvID) {
            thryvId.current = response?.thryvID
          }
          const codes = []

          // adding the plans into the coupon validation
          if (
            transitionData?.state?.keapPartnerLinkDetail?.plan_code.plan &&
            transitionData?.state?.keapPartnerLinkDetail?.plan_code.plan
              .length > 0
          ) {
            for (const plan of transitionData.state.keapPartnerLinkDetail
              .plan_code.plan) {
              if (!plan.code.startsWith('cc')) {
                codes.push(plan.code)
              }
            }
          }

          // adding the addons into the coupon validation
          if (
            transitionData?.state?.keapPartnerLinkDetail?.add_on_code?.addon &&
            transitionData?.state?.keapPartnerLinkDetail?.add_on_code?.addon
              .length > 0
          ) {
            for (const addon of transitionData.state.keapPartnerLinkDetail
              .add_on_code.addon) {
              if (!addon.code.startsWith('cc')) {
                codes.push(addon.code)
              }
            }
          }

          let incentiveCodes =
            transitionData?.state?.keapPartnerLinkDetail?.default_incentive?.defaultIncentives.toString() ||
            ''

          incentiveCodes = incentiveCodes.split(',')
          // let incentiveDetails
          let couponArray = []
          const couponCodes =
            transitionData?.state?.keapPartnerLinkDetail?.coupon_code
              ?.couponCodes ?? []

          if (incentiveCodes.length > 0) {
            for (let incentiveCode of incentiveCodes) {
              if (incentiveCode.length > 0) {
                let incentiveDetail = await run(
                  client(
                    `orders/coupon/validate?couponCode=${incentiveCode}&country=${countryCode}&planCode=${codes.join()}`,
                  ),
                )
                if (incentiveDetail && incentiveDetail?.isValid) {
                  couponArray.push(incentiveDetail)
                }
              }
            }
          }
          if (couponCodes) {
            for (const coupon of couponCodes) {
              const couponDetails = await run(
                client(
                  `orders/coupon/validate?couponCode=${coupon}&country=${countryCode}&planCode=${codes.join()}`,
                ),
              )
              if (couponDetails && couponDetails?.isValid) {
                couponArray.push(couponDetails)
              }
            }
          }
          // if (incentiveDetails && incentiveDetails?.isValid) {
          //   couponArray.push(incentiveDetails)
          // }
          transitionData.state.couponList = couponArray
          transitionData.state.accountInformation = accountInformation
          transitionData.state.linkType = linkType
        } else {
          setIsFetching(false)
          const industryId = 'fpdwyu4e6ly3txw0'
          //  create acc api
          let accountInformation =
            payloadData.accountInformation ||
            transitionData.state.accountInformation
          let keapPartnerLinkDetail = transitionData.state.keapPartnerLinkDetail
          let accountPayload = {
            email: accountInformation.email,
            firstName: accountInformation.firstName,
            lastName: accountInformation.lastName,
            city: accountInformation.city,
            state: accountInformation.state,
            country: accountInformation.country,
            phone: accountInformation.companyPhone,
            industryId: industryId,
            mobile: accountInformation.mobile,
            address: accountInformation.address,
            company: accountInformation.company,
            zipCode: accountInformation.postCode,
            keapID: '',
            keapAccount: false,
            xpCode: '',
            onBehalf: keapPartnerLinkDetail.keap_partner_id,
            keapPartnerId:
              keapPartnerLinkDetail.sf_partner_account_id ||
              keapPartnerLinkDetail.keap_partner_id,
          }
          let account = await run(client('accounts/5', {data: accountPayload}))
          currentStep.current = currentStep.current + 1
          if (account && account.thryvId) {
            thryvId.current = account.thryvId
            let subDetail =
              payloadData?.orderDetail?.productSub ||
              transitionData.state.orderDetail.productSub
            accountInformation = {
              ...accountInformation,
              thryvId: account.thryvId || thryvId.current,
              industryId,
              isInvoiceBilled: false,
            }
            const captureOrderID = await postCreateAccCaptureOrderDetailTrigger(
              account,
              subDetail,
              accountInformation,
            )
            captureOrderHeaderId.current = captureOrderID
            let coupons = transitionData?.state?.couponList.map(
              item => item.code,
            )
            try {
              let updatedSubDetails = formatInCodeQuantityStructure(subDetail)
              let sendLinkPayloadData = {
                ...accountInformation,
                ...updatedSubDetails,
                coupons: coupons,
                overrideRepId: keapPartnerLinkDetail.sf_partner_account_id,
                behalfRepId: keapPartnerLinkDetail.keap_partner_id,
              }
              if (navData?.state?.scheduleKickOffCallDetails) {
                sendLinkPayloadData['onboardingApptId'] =
                  navData?.state?.scheduleKickOffCallDetails?.callDetails
                    ?.apptId || ''
              }
              if (navData?.state?.scheduleCreativeCallDetails) {
                sendLinkPayloadData['creativeApptId'] =
                  navData?.state?.scheduleCreativeCallDetails?.callDetails
                    ?.apptId || ''
              }
              // scheduled appointment table details
              if (navData?.state?.scheduleKickOffCallDetails) {
                await captureAppointment(
                  navData?.state?.scheduleKickOffCallDetails?.callDetails,
                  captureOrderID,
                )
              }
              if (navData?.state?.scheduleCreativeCallDetails) {
                await captureAppointment(
                  navData?.state?.scheduleCreativeCallDetails?.callDetails,
                  captureOrderID,
                )
              }
              const result = await run(
                client('cc/order/send-link', {
                  data: sendLinkPayloadData,
                }),
              )
              if (captureOrderID) {
                await run(
                  client('ordercapture/services/updateOrderStatus', {
                    method: 'PUT',
                    data: {
                      order_id: Number(captureOrderID),
                      cc_order_id: result.orderId,
                      order_status: 'Submitted',
                      userEmailId:
                        transitionData?.state?.keapPartnerLinkDetail
                          ?.partner_email,
                    },
                  }),
                )
              }

              if (result.message === 'Order created') {
                setPaymentUUID(result.paymentUuid)
                setOrdreId(result.orderId)
                // Fetch schedule details for influencer links
                if (
                  transitionData?.state?.keapPartnerLinkDetail?.influencer_name
                ) {
                  try {
                    const scheduleData = await client(
                      `keappartner/fetchScheduleDetails/${captureOrderID}`,
                    )
                    if (scheduleData.success) {
                      setScheduleDetails(scheduleData.data)
                    }
                  } catch (err) {
                    console.log(err)
                  }
                }
              }
            } catch (error) {
              // Wait for 5 second before retrying the API call
              await delay(5000)
              try {
                //retrying to check if it works
                let updatedSubDetails = formatInCodeQuantityStructure(subDetail)
                let sendLinkPayloadData = {
                  ...accountInformation,
                  ...updatedSubDetails,
                  coupons: coupons,
                  overrideRepId: keapPartnerLinkDetail.sf_partner_account_id,
                  behalfRepId: keapPartnerLinkDetail.keap_partner_id,
                }
                if (navData?.state?.scheduleKickOffCallDetails) {
                  sendLinkPayloadData['onboardingApptId'] =
                    navData?.state?.scheduleKickOffCallDetails?.callDetails
                      ?.apptId || ''
                }
                if (navData?.state?.scheduleCreativeCallDetails) {
                  sendLinkPayloadData['creativeApptId'] =
                    navData?.state?.scheduleCreativeCallDetails?.callDetails
                      ?.apptId || ''
                }
                // scheduled appointment table details
                if (navData?.state?.scheduleKickOffCallDetails) {
                  await captureAppointment(
                    navData?.state?.scheduleKickOffCallDetails?.callDetails,
                    captureOrderID,
                  )
                }
                if (navData?.state?.scheduleCreativeCallDetails) {
                  await captureAppointment(
                    navData?.state?.scheduleCreativeCallDetails?.callDetails,
                    captureOrderID,
                  )
                }
                const result = await run(
                  client('cc/order/send-link', {
                    data: sendLinkPayloadData,
                  }),
                )
                if (captureOrderID) {
                  await run(
                    client('ordercapture/services/updateOrderStatus', {
                      method: 'PUT',
                      data: {
                        order_id: Number(captureOrderID),
                        order_status: 'Submitted',
                        userEmailId:
                          transitionData?.state?.keapPartnerLinkDetail
                            ?.partner_email,
                      },
                    }),
                  )
                }
                if (result.message === 'Order created') {
                  setPaymentUUID(result.paymentUuid)
                  setOrdreId(result.orderId)
                  // Fetch schedule details for influencer links
                  if (
                    transitionData?.state?.keapPartnerLinkDetail
                      ?.influencer_name
                  ) {
                    try {
                      const scheduleData = await client(
                        `keappartner/fetchScheduleDetails/${captureOrderID}`,
                      )
                      if (scheduleData.success) {
                        setScheduleDetails(scheduleData.data)
                      }
                    } catch (err) {
                      console.log(err)
                    }
                  }
                }
              } catch (retyError) {
                setIsLoading(false)
                setLoadingTimelineCompletionStatus(true)
                toast.error(
                  `We encountered an error while fetching data, Please contact Admin. Error: ${JSON.stringify(retyError)}`,
                )
              }
            }

            currentStep.current = currentStep.current + 1
            if (currentStep.current >= 2) {
              setLoadingTimelineCompletionStatus(true)
            }
          }
          setIsLoading(false)
          setLoadingTimelineCompletionStatus(true)
        }
      } catch (err) {
        console.log(err)
        setIsLoading(false)
        setLoadingTimelineCompletionStatus(true)

        toast.error(
          `We encountered an error while fetching data, Please contact Admin. Error: ${JSON.stringify(err)}`,
        )
      }
    }
    preLoadApiCall()
  }, [])

  useEffect(() => {
    async function fetchListItem() {
      let data = await run(client('plans/5/v1/list'))
      if (data) {
        setListItem(data)
      }
    }
    async function fetchOrderHeaderId() {
      let {linkId} = transitionData.state
      let captureOrderHeaderDetails = await run(
        client(`keappartner/fetchCaptureOrderHeaderId/${linkId}`),
      )

      if (captureOrderHeaderDetails?.data.length > 0) {
        captureOrderHeaderId.current =
          captureOrderHeaderDetails?.data[0].order_id
      }
    }

    async function fetchLinkExpiryTimeCountDetails() {
      let response = await run(
        client(
          'keappartner/fetchConfigLookupValue/KeapPartnerLinkExpiryInMinutes',
        ),
      )
      if (response?.data.length) {
        setLinkExpiryInMinutes(Number(response.data[0].value) || 0)
      }
    }
    if (transitionData.state.linkType.includes('1:1')) {
      fetchOrderHeaderId()
      fetchLinkExpiryTimeCountDetails()
    }

    fetchListItem()
  }, [])

  useEffect(() => {
    // Scroll to top when loading completes
    if (!_isLoading && !hasScrolledToTop) {
      window.scrollTo({top: 0, behavior: 'smooth'})
      setHasScrolledToTop(true)
    }
  }, [_isLoading, hasScrolledToTop])

  const handleChangePaymentMethod = method => {
    setPaymentMethod(method)
    setType(method.value)
  }
  async function postCreateAccCaptureOrderDetailTrigger(
    thryvAccDetail,
    subDetail,
    accountInformation,
  ) {
    let subDetailsList = [
      ...subDetail.parentSubscriptions,
      ...subDetail.childSubscriptions,
    ]
    let subLines = []
    let count = 0

    for (let i = 0; i < subDetailsList.length; i++) {
      subLines.push(generateLineItem(subDetailsList[i], count))
      if (subDetailsList[i].addons && subDetailsList[i].addons.length > 0) {
        for (let j = 0; j < subDetailsList[i].addons.length; j++) {
          count += 1
          subLines.push(
            generateLineItem(
              subDetailsList[i].addons[j],
              count,
              i,
              subDetailsList[i].code,
            ),
          )
        }
      }
      count += 1
    }
    let couponsDetails = []
    if (transitionData?.couponList) {
      couponsDetails = [...couponsDetails, ...transitionData.couponList]
    }
    if (transitionData?.defaultIncentive) {
      couponsDetails = [...couponsDetails, ...transitionData.defaultIncentive]
    }
    let createCaptureOrderPayload = generateCreateOrderPayload(
      accountInformation,
      {},
      thryvAccDetail,
      subLines,
      couponsDetails,
    )

    let captureOrderResponse = await run(
      client('ordercapture/services/createOrder', {
        method: 'POST',
        data: createCaptureOrderPayload,
      }),
    )
    // if (captureOrderResponse.Success) {
    //   setCaptureOrderId(captureOrderResponse.order_id)
    // }
    return captureOrderResponse.order_id
  }
  function generateDiscountPayload(discounts = [], order_id) {
    let discountPayload = []
    discounts.map((item, index) => {
      // discountPayload.push({order_id, line_number: index + 1, discount_type: ''})
      let itemDetails = {
        order_id,
        line_number: index + 1,
        discount_percentage: item.discountPercent,
        discount_amount: item.discountAmount,
        coupon_code: item.code,
        discount_type: item.type,
        duration: item.durationAmount,
        start_date: dayjs().format('YYYY-MM-DD'),
        end_date: item.durationAmount
          ? dayjs()
              .add(item.durationAmount, item.durationUnit)
              .format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD'),
      }

      discountPayload.push(itemDetails)
      return item
    })
    return discountPayload
  }

  function generateCreateOrderPayload(
    accInfo,
    accDetails,
    acc,
    linesDetails,
    discounts,
  ) {
    // // eslint-disable-next-line no-debugger
    // debugger
    let discountDetails = generateDiscountPayload(discounts) || []
    return {
      order_status: 'Pending',
      order_version: '5.0',
      order_flow: 'New',
      order_submitted_date: new Date(),
      order_submitted_by: 'null',
      order_completed_date: null,
      industry_id: accInfo.industryId,
      industry_description:
        'For Veterinarians, Groomers, Pet Care Services and more.',
      country_code: accInfo.country || 'US',
      account_email: accInfo.email,
      contact_first_name: accInfo.firstName,
      contact_last_name: accInfo.lastName,
      contact_phone: accInfo?.phone || accInfo?.contactPhone,
      contact_mobile: accInfo.mobile,
      contact_email: accInfo.email,
      company_name: accInfo.company,
      company_address1: accInfo.address,
      company_address2: null,
      company_city: accInfo.city,
      company_state: accInfo?.state?.value || accInfo?.state,
      company_zipcode: accInfo?.postalCode || accInfo?.postCode,
      company_phone: accInfo?.phone || accInfo?.companyPhone,
      sales_rep_id: null,
      on_behalf_of: null,
      xp_code: null,
      abn: null,
      thryv_id: acc?.thryvId,
      account_code: acc?.ccId,
      eaid: accDetails?.accountInfo?.eaid || 'keapClientPlaceHolder',
      is_invoice_billed: 0,
      is_cohort: null,
      demo_lead_id: null,
      no_service: null,
      onboard_appt_id:
        navData?.state?.scheduleKickOffCallDetails?.callDetails?.apptId || null,
      creative_appt_id:
        navData?.state?.scheduleCreativeCallDetails?.callDetails?.apptId ||
        null,
      update_to_autopay: 1,
      on_boarding_fee: 0,
      purchase_intent_1: null,
      purchase_intent_2: null,
      purchase_intent_3: null,
      sensis_site: null,
      discounts: discountDetails,
      reseller: [],
      keap_account: false,
      lines: linesDetails,
      link_id: transitionData?.state?.linkId,
    }
  }

  function generateLineItem(
    subDetail,
    index,
    parentIndex = null,
    parentSubCode = null,
  ) {
    let isCenter = listItem.centers.find(item => item.code === subDetail.code)
    let isOneTimeFee = listItem.oneTimeFees?.find(
      item => item.code === subDetail.code,
    )
    let isApp = listItem.apps.find(item => item.code === subDetail.code)
    let plansv5_id = ''
    let saas_product_category = ''
    let saas_product_type = ''
    let recurly_subscription_id = null
    let unit_cost = 0
    let quantity = 1
    let total_cost = unit_cost * quantity
    let parent_line_number =
      parentIndex !== null ? parentIndex + 1 : parentIndex

    if (isApp) {
      saas_product_category = 'App'
      saas_product_type = 'addon'
      plansv5_id = isApp.id
    } else if (isCenter) {
      saas_product_category = 'Center'
      saas_product_type = 'main'
      plansv5_id = isCenter.id
      unit_cost = isCenter?.unitAmount || 0
      quantity = isCenter?.quantity || 1
      total_cost = unit_cost * quantity
    } else if (isOneTimeFee) {
      saas_product_category = 'OneTimeFee'
      saas_product_type = 'oneTimeFee'
      plansv5_id = isOneTimeFee.id
      unit_cost = isCenter?.unitAmount || 0
      quantity = isCenter?.quantity || 1
      total_cost = unit_cost * quantity
    } else if (subDetail.code === 'appmarket-5-thryv-m2m') {
      saas_product_category = 'App'
      saas_product_type = 'addon'
      plansv5_id = 'wo6lpqm9wsxn'
      unit_cost = isApp?.unitAmount || 0
      quantity = isApp?.quantity || 1
      total_cost = unit_cost * quantity
    }
    if (parentSubCode) {
      saas_product_category = 'App'
      saas_product_type = 'addon'
      if (parentSubCode === 'appmarket-5-thryv-m2m') {
        if (!plansv5_id) {
          plansv5_id = 'wo6lpqm9wsxn'
        } else {
          parent_line_number = null
        }
      } else {
        plansv5_id =
          [...listItem.centers, ...listItem.apps, ...listItem.oneTimeFees].find(
            item => item.code === parentSubCode,
          )?.id || 'wo6lpqm9wsxn'
      }
    }
    return {
      line_number: index + 1,
      parent_line_number,
      plansv5_id,
      action_code: 'New',
      order_line_status: 'InProgress',
      saas_product_category,
      saas_product_type,
      saas_product_code: subDetail.code,
      saas_instance_id: null,
      recurly_subscription_id,
      total_cost,
      unit_cost,
      quantity,
      start_date: new Date(),
      end_date: null,
    }
  }
  // Function to complete the purchase flow
  const completePurchaseFlow = async () => {
    setIsLoading(true)
    let purchaseData
    try {
      purchaseData = await run(
        client('cc/order/process-purchase', {
          data: {
            orderId: orderId.toString(),
          },
        }),
      )
      if (transitionData.state.linkType.includes('1:1')) {
        await run(
          client(`keappartner/updateKeapPartnerLinkStatus`, {
            data: {linkId: transitionData.state.linkId, status: 'Completed'},
            method: 'PUT',
          }),
        )
        let orderHeaderIdRes = await client(
          `ordercapture/services/getOrderDetailsByLinkId/${transitionData.state.linkId}`,
        )
        if (
          orderHeaderIdRes &&
          orderHeaderIdRes['success'] &&
          orderHeaderIdRes['response']['data'] &&
          orderHeaderIdRes['response']['data'].length > 0
        ) {
          const orderHeaderId = orderHeaderIdRes['response']['data'][0].order_id
          captureOrderHeaderId.current = orderHeaderId
        }
      }
    } catch (err) {
      toast.error(err.message)
      setIsLoading(false)
      return undefined
    }

    if (captureOrderHeaderId.current) {
      await run(
        client('ordercapture/services/updateOrderStatus', {
          method: 'PUT',
          data: {
            order_id: Number(captureOrderHeaderId.current),
            order_status: 'Completed',
            userEmailId:
              transitionData?.state?.keapPartnerLinkDetail?.partner_email,
          },
        }),
      )
    }
    let data = {
      linkId: transitionData.state.linkId,
      currentScreen: 'paymentInfo',
      baseUrl: window.location.href,
    }
    await run(
      client('keappartner/updatePartnerActivity', {
        data,
        method: 'PUT',
      }),
    )
    let orderDetails = {
      clientName:
        transitionData.state.accountInformation.firstName +
        ' ' +
        transitionData.state.accountInformation.lastName,
      clientEmailId: navData?.state?.custEmail
        ? navData?.state?.custEmail
        : transitionData?.state?.accountInformation?.email,
      baseUrl: window.location.href,
      planName:
        transitionData?.state?.orderDetail?.plans
          .filter(item => !NON_ADDED_PLANS.includes(item.code))
          .map(item => item.name) || [],
      companyName: transitionData.state.accountInformation.company,
      linkId: transitionData.state.linkId,
      thryvId: thryvId.current,
    }
    await run(
      client('keappartner/sendPurchseOrderDetails', {
        data: orderDetails,
        method: 'POST',
      }),
    )
    toast.success('Order was successfully created.')
    setIsLoading(false)
    if (purchaseData) {
      navigate('/client-acknowledgement', {
        state: {
          name: transitionData.state.accountInformation.firstName,
          orderId,
          linkId: transitionData.state.linkId,
          scheduleDetails,
          influencer_name:
            transitionData?.state?.keapPartnerLinkDetail?.influencer_name,
        },
      })
    }
  }

  const calculateTaxes = async paymentResponse => {
    try {
      setCalculatingTaxes(true)
      setIsLoading(true)
      toast.info(
        'Tax is being calculated based on your business address. The final amount will be updated shortly.',
      )
      const data = getBillingSaveData(paymentResponse)
      let url = 'cc/order/save-billing'
      const result = await client(url, {data})
      if (result) {
        // Tax calculation completed
      }
      try {
        let previewResponse = await client(
          `cc/order/purchase-plan/${paymentUUID}`,
        )
        // console.log({previewResponse})
        setPreviewDetails(previewResponse)
      } catch (err) {
        console.log(err)
        return undefined
      }
      setTaxCalculateStatus(true)
      setCalculatingTaxes(false)
      setIsLoading(false)
    } catch (error) {
      if (error.errors) {
        error.errors.forEach(({message}) => toast.error(message))
      } else {
        toast.error(error.message)
      }
      setCalculatingTaxes(false)
      setIsLoading(false)
    }
  }

  const handlePaymentDetailContinue = async () => {
    if (!checkBoxesValues.agreedTerms) {
      toast.warn('Please agree to the Terms and Conditions to continue.')
      return null
    }
    setIsLoading(true)

    await completePurchaseFlow()
  }
  const getBillingSaveData = paymentResponse => {
    return {
      orderUuid: paymentUUID,
      billingMethod: paymentMethod?.value === 'Card' ? 'CC' : 'ACH',
      recurlyToken: paymentResponse ? paymentResponse.id : undefined,
    }
  }

  async function captureAppointment(data, orderHeaderId) {
    console.log('new', data)
    const createAppointModel = []
    const appointmentObj = {
      order_id: orderHeaderId,
      schedule_status: 'Scheduled',
      appointment_type: data.appointment_type,
      timezone: data.timeZone,
      appt_id: data.apptId,
      date: data.thryvBookingDate.split('T')[0],
      time: data.thryvBookingDate.split('T')[1],
      title: 'Meeting Connect',
      duration: 30,
      service_id: data.serviceId,
      staff_id: data.staffId,
      interaction: 'call Interaction',
      zoomURL: 'https://www.zoom.com',
      create_user: null,
      update_user: null,
    }
    createAppointModel.push(appointmentObj)
    try {
      let result
      let url = 'ordercapture/services/createAppointment'
      result = await kP11LinkService.captureAppoinmentDetail(
        client,
        url,
        createAppointModel,
      )
      console.log(result)
    } catch (error) {
      if (error.status !== 400) {
        console.log('error in captureAppointment', error)
      }
      if (error.errors) {
        console.log('error in captureAppointment', error)
      }
    }
  }

  function getLoadingMessage({
    calculatingTaxes,
    isVerifying,
    isFetching,
    isFetchingRecurly,
    isAus,
  }) {
    if (calculatingTaxes) {
      return isAus ? 'Generating token' : 'Calculating your Taxes & Fees'
    }
    if (isVerifying) {
      return 'Verifying CVC'
    }
    if (isFetching) {
      return 'Fetching card on file'
    }
    if (isFetchingRecurly) {
      return 'Generating token'
    }
    return 'Processing'
  }

  React.useEffect(() => {
    if (isAgreeCheckboxDisabled) {
      clearRecurlyToken()
      return undefined
    }
    if (!recurlyToken && !isCVCVerified) return undefined
    if (is5Order) {
      // calculateTaxesCC(recurlyToken)
      calculateTaxes(recurlyToken)
    } else {
      calculateTaxes(recurlyToken)
    }
  }, [is5Order, recurlyToken, isCVCVerified, isAgreeCheckboxDisabled])

  React.useEffect(() => {
    if (isAgreeCheckboxDisabled && currentStep <= 3) {
      dispatch(clearRecurlyTokenData())
      return undefined
    }
    if (!recurlyTokenDetail) return undefined
    if (is5Order) {
      // calculateTaxesCC(recurlyToken)
      calculateTaxes(recurlyTokenDetail)
    } else {
      calculateTaxes(recurlyTokenDetail)
    }
  }, [is5Order, recurlyTokenDetail, isAgreeCheckboxDisabled])

  const displayLoading = calculatingTaxes && _isLoading
  const loadingMessage = getLoadingMessage({
    isFetching,
    isFetchingRecurly: isFetching,
    isVerifying,
    calculatingTaxes,
  })

  return (
    <>
      {isLoading && <AppSpinner />}
      {displayLoading && (
        <div className="p-4" style={{position: 'relative'}}>
          <OverlayLoader
            is5Order={is5Order}
            className="d-flex justify-content-center align-items-center w-100 position-fixed"
          >
            <ParagraphText
              variant="lg"
              color="thryv-white-50"
              className="font-weight-bold mt-24 pt-10"
            >
              <AppSpinner />
              {loadingMessage}
            </ParagraphText>
          </OverlayLoader>
        </div>
      )}
      <BlueGradientBackground showLogo={false} backgroundHexColor="#F4F6FB" />
      <ThryvAndKeapHeader />
      {isMobileViewEnable ? (
        <section
          className={`payment-container d-flex  flex-column ${!_isLoading ? '' : 'overlay--style'}`}
        >
          <section
            className="payment-details-sidebar"
            style={{
              width: '80%',
              borderRadius: '12px',
              margin: 'auto',
              padding: '0px 20px',
            }}
          >
            <p
              style={{
                paddingTop: '20px',
                fontWeight: 700,
                fontStyle: 'bold',
                fontFamily: 'Open Sans',
                fontSize: '20px',
                marginBottom: '32px',
                color: 'black',
              }}
            >
              Payment Details
            </p>

            <section className="payment-details-container">
              <KCPPaymentDetails
                paymentState={dataJSON}
                cartDetailObj={transitionData.state.orderDetail}
                paymentDetailType="monthly"
                currentScreen={'paymentInfo'}
              />
              <KCPPaymentDetails
                paymentState={dataJSON}
                paymentDetailType="today"
                cartDetailObj={transitionData.state.orderDetail}
                finalBillingAmountDetails={finalBillingAmountDetails}
                currentScreen={'paymentInfo'}
                couponList={transitionData.state.couponList}
                previewDetails={previewDetails}
                preselectedSubData={preselectedSubData}
              />
            </section>
            <ParagraphText
              variant="reg"
              style={{
                marginTop: '8px',
                marginBottom: '8px',
                color: '#121212',
                fontFamily:
                  'Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif',
                fontSize: '14px',
                lineHeight: '24px',
                textAlign: 'center',
              }}
            >
              Future invoices will include any eligible discount for as long as
              your account qualifies.
            </ParagraphText>
            {/* <section
              className="payment-details-section"
              style={{
                // width: '80%',
                // marginTop: '32px',
                padding: '0px',
                // marginLeft: '10%',
              }}
            > */}
            <div
              className={`${isMobileViewEnable ? 'payment-card-m' : 'payment-card'}`}
            >
              {paymentCurrentStep === 1 && (
                <p
                  style={{
                    paddingTop: '20px',
                    fontWeight: 700,
                    fontStyle: 'bold',
                    fontFamily: 'Open Sans',
                    fontSize: '20px',
                    marginBottom: '32px',
                    color: 'black',
                  }}
                >
                  Select Payment Method
                </p>
              )}

              {transitionData.state.linkType.includes('1:1') &&
                scheduleDetails.startTime && (
                  <CountdownTimer
                    type="Schedule"
                    countdownTimeMS={
                      new Date(scheduleDetails.startTime).getTime() +
                      (linkExpiryInMinutes * 60000 + 1000)
                    }
                    isHourlyNeeded={linkExpiryInMinutes > 59}
                  />
                )}

              <PaymentMethodComponent
                paymentState={dataJSON}
                setRecurlyToken={setRecurlyToken}
                setTaxCalculateStatus={setTaxCalculateStatus}
                isTaxCalculated={isTaxCalculated}
                calculateTaxes={calculateTaxes}
                paymentUUID={paymentUUID}
                accountInformation={
                  payloadData?.accountInformation ||
                  transitionData?.accountInformation ||
                  transitionData?.state?.accountInformation
                }
                handleChangePaymentMethod={handleChangePaymentMethod}
                paymentMethod={paymentMethod}
                setPaymentRequestState={() => {}}
                country={
                  transitionData?.state?.keapPartnerLinkDetail?.country_code ||
                  'US'
                }
                keapPartnerLinkDetail={
                  transitionData?.state?.keapPartnerLinkDetail
                }
              />
              {paymentCurrentStep === 1 && <AutopayTerms />}
              {paymentCurrentStep > 3 && (
                <AgreedTermNote
                  setCheckBoxesValues={setCheckBoxesValues}
                  checkBoxesValues={checkBoxesValues}
                  isAgreeCheckboxDisabled={isAgreeCheckboxDisabled}
                  isTaxCalculated={isTaxCalculated}
                />
              )}

              {paymentCurrentStep === 1 && (
                <Button
                  variant="primary"
                  onClick={() => {
                    dispatch(nextPaymentStep())
                  }}
                  style={{
                    width: '150px',
                    height: '40px',
                    fontSize: '15px',
                    margin: 'auto',
                  }}
                  disabled={paymentMethod?.value.length === 0}
                >
                  Continue
                </Button>
              )}
              {paymentCurrentStep > 3 && (
                <button
                  type="button"
                  className="complete-purchase-btn"
                  onClick={handlePaymentDetailContinue}
                  disabled={!isTaxCalculated}
                >
                  Complete Purchase
                </button>
              )}
            </div>
            {/* </section> */}
          </section>

          {!isLoadingTimelineCompleted && (
            <LoadingTimelineModal currentStep={currentStep.current} />
          )}
        </section>
      ) : (
        <section
          className={`payment-container row w-90 ${!_isLoading ? '' : 'overlay--style'}`}
        >
          <section className="payment-details-section">
            <h2 className="payment-title">Payment</h2>
            <div className="payment-card">
              <ParagraphText variant="lg" className="payment-method-title">
                Select Payment Method
              </ParagraphText>
              {transitionData.state.linkType.includes('1:1') &&
                scheduleDetails.startTime && (
                  <CountdownTimer
                    type="Schedule"
                    countdownTimeMS={
                      new Date(scheduleDetails.startTime).getTime() +
                      (linkExpiryInMinutes * 60000 + 1000)
                    }
                    isHourlyNeeded={linkExpiryInMinutes > 59}
                  />
                )}
              <PaymentMethodComponent
                paymentState={dataJSON}
                setRecurlyToken={setRecurlyToken}
                setTaxCalculateStatus={setTaxCalculateStatus}
                isTaxCalculated={isTaxCalculated}
                calculateTaxes={calculateTaxes}
                paymentUUID={paymentUUID}
                accountInformation={
                  payloadData?.accountInformation ||
                  transitionData?.accountInformation ||
                  transitionData?.state?.accountInformation
                }
                handleChangePaymentMethod={handleChangePaymentMethod}
                paymentMethod={paymentMethod}
                setPaymentRequestState={() => {}}
                country={
                  transitionData?.state?.keapPartnerLinkDetail?.country_code ||
                  'US'
                }
                keapPartnerLinkDetail={
                  transitionData?.state?.keapPartnerLinkDetail
                }
              />
              <AgreedTermNote
                setCheckBoxesValues={setCheckBoxesValues}
                checkBoxesValues={checkBoxesValues}
                isAgreeCheckboxDisabled={isAgreeCheckboxDisabled}
                isTaxCalculated={isTaxCalculated}
              />
              <button
                type="button"
                className="complete-purchase-btn"
                onClick={handlePaymentDetailContinue}
                disabled={!isTaxCalculated}
              >
                Complete Purchase
              </button>
            </div>
          </section>
          <section className="payment-details-sidebar">
            <h2 className="payment-details-title">Payment Details</h2>

            <section className="payment-details-container">
              <KCPPaymentDetails
                paymentState={dataJSON}
                cartDetailObj={transitionData.state.orderDetail}
                paymentDetailType="monthly"
                currentScreen={'paymentInfo'}
              />
              <KCPPaymentDetails
                paymentState={dataJSON}
                paymentDetailType="today"
                cartDetailObj={transitionData.state.orderDetail}
                finalBillingAmountDetails={finalBillingAmountDetails}
                currentScreen={'paymentInfo'}
                couponList={transitionData.state.couponList}
                previewDetails={previewDetails}
                preselectedSubData={preselectedSubData}
              />
            </section>
            <ParagraphText
              variant="reg"
              style={{
                marginTop: '8px',
                marginBottom: '8px',
                color: '#121212',
                fontFamily:
                  'Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif',
                fontSize: '14px',
                lineHeight: '24px',
                textAlign: 'center',
              }}
            >
              Future invoices will include any eligible discount for as long as
              your account qualifies.
            </ParagraphText>
          </section>
          {!isLoadingTimelineCompleted && (
            <LoadingTimelineModal currentStep={currentStep.current} />
          )}
        </section>
      )}
    </>
  )
}
